import { RoleDto } from "@admin_api/models/role-dto";
import { UserDetailsDto } from "@admin_api/models/user-details-dto";

export class UserState {
    loading = false;
    error = null;
    user: UserDetailsDto = null;
    roleList: RoleDto[] = null;
}
